import React, { useRef } from 'react'
import { useDrag, useDrop, DropTargetMonitor } from 'react-dnd'

import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'

import settings from 'settings'

const UnfoldMoreIcon = settings.icons.drag

const styles = {
  container: {
    cursor: 'move',
    width: '100%',
  },
  draggable: {
    paddingLeft: '0px',
  },
  icon: {
    minWidth: '0px',
  }
}

const SortableListItem = ({
  index,
  onSwap,
  children,
}) => {

  const ref = useRef(null)

  const [, drop] = useDrop({
    accept: 'listitem',
		hover(item, monitor) {
			if (!ref.current) {
				return
			}
			const dragIndex = item.index
			const hoverIndex = index

			// Don't replace items with themselves
			if (dragIndex === hoverIndex) {
				return
			}

			// Determine rectangle on screen
			const hoverBoundingRect = ref.current?.getBoundingClientRect()

			// Get vertical middle
			const hoverMiddleY =
				(hoverBoundingRect.bottom - hoverBoundingRect.top) / 2

			// Determine mouse position
			const clientOffset = monitor.getClientOffset()

			// Get pixels to the top
			const hoverClientY = (clientOffset).y - hoverBoundingRect.top

			// Only perform the move when the mouse has crossed half of the items height
			// When dragging downwards, only move when the cursor is below 50%
			// When dragging upwards, only move when the cursor is above 50%

			// Dragging downwards
			if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
				return
			}

			// Dragging upwards
			if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
				return
			}

      onSwap(dragIndex, hoverIndex)

			item.index = hoverIndex
		},
  })
  
  const [, drag] = useDrag({
		item: {
      type: 'listitem',
      id: index,
      index,
    },
  })

  drag(drop(ref))

  return (
    <div ref={ ref } style={ styles.container }>
      <ListItem style={ styles.draggable }>
        <ListItemIcon style={ styles.icon }>
          <UnfoldMoreIcon />
        </ListItemIcon>
        { children }
      </ListItem>
    </div>
  )
}

export default SortableListItem